import { ANIMATE } from '@namespace/top/animate'
import { VIDEO } from '@namespace/top/video'

export default function top() {
  window.addEventListener('load', () => {
    ANIMATE.init()
    VIDEO.init()

    // cdbs
    const cdbs = document.querySelector('.js-cdbs')
    const cdbsEl = document.querySelector('.js-cdbs__element')
    const fitClass = 'is-fit'

    if (cdbs && cdbsEl) {
      const fitPosition = cdbs.offsetTop + 50 + cdbsEl.offsetHeight
      const handleScroll = () =>
        cdbsEl.classList.toggle(fitClass, window.scrollY + window.innerHeight >= fitPosition)

      window.addEventListener('scroll', handleScroll)
      handleScroll()
    }
  })
}
